import React, {Component} from 'react';
// import {Row, Grid, Col} from 'react-bootstrap';
import {List, Segment} from 'semantic-ui-react';
import {getSelectedOffice } from "../../../../Global/CustomFunctions";

class contactInfoView extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {          
      Hide:true
    };    
  }
  componentWillMount(){
      let SelectedOffice=getSelectedOffice();
      let res=(SelectedOffice.Country?.toLocaleLowerCase().indexOf("pakistan")>0)?true:false;
      this.setState({Hide:res});
    }
  render() {
    let {data} = this.props;
    let Hide=this.state.Hide;
    return (
      <Segment.Group className="BasicInfoCnt">
        <Segment basic>
          <h1 className="textStyleHeading">Contact Information</h1>
          <List className="userDataList">
            <List.Item>
              <label className="titleLabel">Land Line:</label>
              <label>
                {data.PhoneNumber}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Emergency Contact Name:</label>
              <label>
                {data.EmergencyContactName != null
                  ? data.EmergencyContactName
                  : 'N/A'}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel">Emergency Contact Number:</label>
              <label>
                {data.EmergencyContactNumber != null
                  ? data.EmergencyContactNumber
                  : 'N/A'}
              </label>
            </List.Item>
            <List.Item className={`${Hide ? "hide" : ""}`}>
              <label className="titleLabel">Postal Code:</label>
              <label>
                {data.PostalCode != null
                  ? data.PostalCode
                  : 'N/A'}
              </label>
            </List.Item>
            <List.Item>
              <label className="titleLabel WideLabelTitle">Permanent Address:</label>
              <label className='WideLabelValue'>
                {data.PermanentAddress}
              </label>
            </List.Item>

            <List.Item>
              <label className="titleLabel WideLabelTitle">Residential Address:</label>
              <label className='WideLabelValue'>
                {data.ResidentialAddress}
              </label>
            </List.Item>
          </List>
        </Segment>
      </Segment.Group>
    );
  }
}

export default contactInfoView;
